import { smb_fetch, getAgpAgmsApiUrl, getTapUrl } from '@/api/operator/fetch';

/**
 * 获取用户注册的资质列表
 *
 * user_id 必传
 * approval_status 审核状态:0 待审核，1 通过，2 拒绝,可用值:PENDING,PASSED,DENIED
 */
export const getUserCert = (data: {
  user_id: number;
}) => {
  const url = getAgpAgmsApiUrl('user_cert', 'get');
  const params = $.extend(
    true,
    {
      method: 'post',
    },
    {
      data,
    },
  );
  return smb_fetch<any>(url, params);
};

/**
 * 获取工作台列表
 */
export const getBusinessList = (data: {
  user_id: number;
}) => {
  const url = getTapUrl('user_account', 'list_business');
  const params = $.extend(
    true,
    {
      method: 'post',
      contentType: 'application/json',
    },
    {
      data,
    },
  );
  return smb_fetch<any>(url, params);
};

/**
 * 拉取的游离于bm之外的账号
 */
export const getUnassignedAccountInfoList = (data: {
  user_id: number;
}) => {
  const url = getTapUrl('account', 'get_unassigned_account_info_list');
  const params = $.extend(
    true,
    {
      method: 'post',
      contentType: 'application/json',
    },
    {
      data,
    },
  );
  return smb_fetch<any>(url, params);
};


